import Parvus from 'parvus'

(function () {

  // Parvus lightbox gallery is used on the site for image galleries.
  if (document.querySelector('.parvus-gallery')) {
    const parvus_l10n_fr = { // French localization
      lightboxLabel: 'Ceci est une fenêtre de dialogue qui se superpose au contenu principal. Elle affiche l’image sélectionnée en format agrandie. En appuyant sur la touche Echap, vous fermerez la fenêtre et reviendrez à l’endroit où vous étiez sur la page.',
      lightboxLoadingIndicatorLabel: 'Chargement de l’image',
      previousButtonLabel: 'Image précédente',
      nextButtonLabel: 'Image suivante',
      closeButtonLabel: 'Fermer la fenêtre de dialogue',
    };
    const prvs = new Parvus({
      gallerySelector: '.parvus-gallery',
      l10n: parvus_l10n_fr,
    })
  }

})()
